import {
    apiRequest,
    golonganCreate
} from "../../../../../services/adapters/kepegawaian/golonganService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", golonganCreate, {
            body: query
        }, true)
    }
}

export default CreateRepository